import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getDocumentsFailure(draft: Draft<IInterventionData>) {
  draft.getDocuments.config.isLoading = false;
}

export default getDocumentsFailure;
